import { render, staticRenderFns } from "./SithMesReportTemplateRoleList.vue?vue&type=template&id=b0c6f5cc&"
import script from "./SithMesReportTemplateRoleList.vue?vue&type=script&lang=js&"
export * from "./SithMesReportTemplateRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports